module.exports = "<button\n  type=\"button\"\n  class=\"help-button\"\n  ng-class=\"{\n    'help-button--sm': $ctrl.size === 'sm',\n    'help-button--lg': $ctrl.size === 'lg',\n    'help-button--labeled': !!$ctrl.label\n  }\"\n  ng-if=\"$ctrl.isVisible()\"\n  ng-click=\"$ctrl.openHelp()\"\n  title=\"{{ $ctrl.getTitle() }}\"\n  aria-label=\"{{ $ctrl.getTitle() }}\">\n  <i class=\"fa-light fa-circle-question\"></i>\n  <span class=\"help-button__label\" ng-if=\"$ctrl.label\">{{ $ctrl.label }}</span>\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./client/help/help-button/help-button.html
// module id = 1435
// module chunks = 0